import { gql } from "config/graphql";
import { IProfile } from "config/types";
import { gqlQuery } from "store/apollo";

interface IFetchProfileResponse {
  data: {
    me: IProfile;
  };
}

export const fetchProfile = (): Promise<IFetchProfileResponse> => {
  const query = gql`
    query currentUserProfile {
      me {
        birthdate
        firstName
        gender
        lastName
        middleName
        suffix
        emails {
          id
          email
          status
        }
        phoneNumbers {
          id
          createdAt
          phoneNumber
          status
          mask
        }
        activeAddress {
          formattedDisplay
          street1
          street2
          city
          state
          postalCode
          country {
            id
            name
            alpha2
            alpha3
            hasStates
            hasPostalCode
            postalCodeFormat
          }
          stateObject {
            id
            name
            alpha2
          }
        }
      }
    }
  `;

  return gqlQuery<IFetchProfileResponse["data"]>({ query });
};

interface IProfileReviewPersonalInfoResponse {
  data: {
    me: Omit<IProfile, "emails">;
  };
}

export const fetchProfileReviewPersonalInfo = (): Promise<IProfileReviewPersonalInfoResponse> => {
  const query = gql`
    query ProfileReviewPersonalInfo {
      me {
        activeAddress {
          city
          formattedDisplay
          postalCode
          state
          street1
          street2
        }
        birthdate
        firstName
        gender
        lastName
        middleName
        phoneNumbers {
          createdAt
          id
          phoneNumber
          status
        }
        suffix
        taxIdSet
      }
    }
  `;

  return gqlQuery<IProfileReviewPersonalInfoResponse["data"]>({ query });
};
